import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FiX } from "react-icons/fi";
import { twMerge } from "tailwind-merge";

export const BackButton = ({ className, path, isRelative=true }) => {
    const navigate = useNavigate();

    const handleClickToLink = () => {
        return navigate(`${path ? `/${path}` : "/"}`)
    } 

    return (
        <motion.button
            className={twMerge(`${ isRelative ? "relative" : "lg:absolute z-10 fixed lg:right-0 right-10 lg:top-0 top-6" }  border border-slate-400 bg-slate-200/20  rounded-full p-2`, className)}
            onClick={handleClickToLink}
            whileHover={{ 
                scale: 1.045
            }}
            whileTap={{
                scale: 0.945,
            }}

            type="button"
        >
            <span className="font-bold lg:text-2xl text-xl text-slate-400"
            ><FiX /></span>
        </motion.button>
    )
}